import { render, staticRenderFns } from "./NavbarSection.vue?vue&type=template&id=673636c5&scoped=true"
import script from "./NavbarSection.vue?vue&type=script&lang=js"
export * from "./NavbarSection.vue?vue&type=script&lang=js"
import style0 from "./NavbarSection.vue?vue&type=style&index=0&id=673636c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673636c5",
  null
  
)

export default component.exports